import { Link } from "react-router";
import { FaTiktok, FaInstagram, FaLinkedin } from "react-icons/fa";
import { CONTACT_EMAIL, SOCIAL_LINKS, BRAND } from "../constants/config";
import StoreBadges, { areStoreLinksAvailable } from "./StoreBadges";

const SOCIAL_ICONS = {
  tiktok: FaTiktok,
  instagram: FaInstagram,
  linkedin: FaLinkedin,
};

export function Footer({ compact = false }) {
  return (
    <footer
      className={`bg-gray-900 text-gray-300 px-6 ${compact ? "py-6" : "py-12"}`}
    >
      <div className="container mx-auto max-w-6xl">
        <div
          className={`grid grid-cols-1 md:grid-cols-2 ${
            compact ? "gap-6 mb-6" : "gap-10 mb-10"
          }`}
        >
          <div className="text-center md:text-left">
            <p className="font-semibold text-white mb-1">{BRAND.name}</p>
            <p className="text-sm">© 2026 {BRAND.name}. Tous droits réservés.</p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-sm text-gray-400 hover:text-white transition mt-1 inline-block"
            >
              {CONTACT_EMAIL}
            </a>
          </div>

          <div className="text-center md:text-left">
            <p className="font-semibold text-white mb-3">Liens</p>
            <div className="flex flex-wrap justify-center md:justify-start gap-4 mb-4">
              <Link
                to="/candidats"
                className="text-sm text-gray-400 hover:text-white transition"
              >
                Candidats
              </Link>
              <Link
                to="/entreprises"
                className="text-sm text-gray-400 hover:text-white transition"
              >
                Entreprises
              </Link>
              <Link
                to="/mentions-legales"
                className="text-sm text-gray-400 hover:text-white transition"
              >
                Mentions légales
              </Link>
              <Link
                to="/politique-de-confidentialite"
                className="text-sm text-gray-400 hover:text-white transition"
              >
                Confidentialité
              </Link>
            </div>
            <div className="flex gap-4 justify-center md:justify-start">
              {Object.entries(SOCIAL_LINKS).map(([key, url]) => {
                const Icon = SOCIAL_ICONS[key];
                if (!Icon || !url) return null;

                return (
                  <a
                    key={key}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-white transition text-xl"
                    aria-label={key}
                  >
                    <Icon />
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {areStoreLinksAvailable() && (
          <div className="border-t border-gray-800 pt-8 flex justify-center">
            <StoreBadges />
          </div>
        )}

        <div
          className={`text-center ${
            areStoreLinksAvailable() ? "pt-6" : "border-t border-gray-800 pt-6 mt-2"
          }`}
        >
          <p className="text-xs text-gray-500">
            Site créé par{" "}
            <a
              href="https://jossbvd.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition"
            >
              JossBvd
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
